import React from "react";
import { Container } from "reactstrap";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { SUPPORT_EMAIL } from "../components/Footer";
import "./Policies.css";

const ReportAbusePage = () => (
  <>
    <Navbar />
    <main className="hn-policies-main">
      <Container className="py-4 py-md-5">
        <h1 className="hn-policies-title">Report Abuse</h1>
        <div className="hn-policies-body">
          <p>
            Hosting Noodle is a platform that&apos;s committed to a better Internet. If you know about, or are a victim of, abuse on a service hosted by Hosting Noodle, you can use this form to report the problem to our team.
          </p>
          <p>
            Please send a detailed report to our abuse team. Include as much information as you can: the service or URL involved, the type of abuse (e.g. spam, malware, phishing, copyright infringement), and any relevant evidence or logs. We will investigate and take appropriate action in line with our Terms of Service and Acceptable Use Policy.
          </p>
          <p className="mb-0">
            <strong>Email:</strong>{" "}
            <a href={`mailto:${SUPPORT_EMAIL}?subject=Abuse%20Report`}>{SUPPORT_EMAIL}</a>
          </p>
        </div>
      </Container>
    </main>
    <Footer />
  </>
);

export default ReportAbusePage;
